module.exports = __webpack_public_path__ + "media/images/country_flags/br-5931161ebf6eae2bfec7d753e0c53519.png";